export const fieldPolicies = {
  PossibleFiltersOutput: {
    keyFields: [],
  },
  PossibleFiltersV2OutputType: {
    keyFields: [],
  },
};
